//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

// Depends on moment.js library.
(function() {
  angular.module('curalate').component('sourceTrackingStatus', {
    template: require('@legacy-components/discover/detail-v2/source-tracking-status.html'),
    bindings: {
      trackStatusObservable: '<',
    },
    controller: [
      '$state',
      'ContentTrackingStatus',
      function(
                $state,
                ContentTrackingStatus,
            ) {
        const self = this;

        const trackingStateToProgress = {
          untracked: 0,
          tracked: 0,
          tracking: 'indeterminate',
          tracking_success: 1,
          unknown: -1,
        };

        this.$onInit = function() {
          self.trackingStatus = ContentTrackingStatus.UNTRACKED;

          self.trackStatusObservable.subscribe((status) => {
            self.trackingStatus = status;
            self.showTrackingProgress = (status && status !== ContentTrackingStatus.TRACKED && status !== ContentTrackingStatus.UNTRACKED);
          });

          self.trackingProgress = function() {
            return trackingStateToProgress[self.trackingStatus];
          };

          self.reload = function() {
            $state.reload();
          };
        };
      },
    ],
  });
})();
